<template>
    <div>
        <el-button  @click="dialogVisible = true" type="text" size="mini" class="avatar">
            <el-avatar icon="el-icon-user-solid" :size="35" style="margin: 0 10px;"></el-avatar>
        </el-button>

        <el-dialog title="Sign Up / Sign In" :visible.sync="dialogVisible" width="360px" :before-close="onClose">
            <el-tabs stretch=true>
            <el-tab-pane v-for="item in tabLabels" :key="item" :label="item">
                <SignUp :on-close="onClose" v-if="item === 'Sign Up'"/>
                <Login :on-close="onClose" v-else />
            </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import SignUp from './SignUp';
import Login from './Login';

export default {
    name: "User",
    components: {
        SignUp,
        Login,
        // eslint-disable-next-line vue/no-unused-components
        Icon
    },
    data: function () {
        return {
            recaptchaSitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            dialogVisible : false,
            tabLabels: ["Sign In","Sign Up"],
            isUserLoggedIn: false
        }
    },
    methods: { 
        onClose(){
            this.dialogVisible= false
            this.$eventHub.$emit('RESET_FORM')
        },
    },
};
</script>

<style scoped>

.sign-up-login-form{
    padding-bottom:30px;
}
.user {
    position: absolute;
    right: 20px;
    bottom: 50%;
    transform: translateY(50%);
    color:white;
}
.user:hover{
    color: #3e9dfb;
}

>>>div.el-dialog__header,
>>>div.el-dialog__body {
    background: #2A2A3D;
    text-align: left;
}

>>>span.el-dialog__title,
>>>.el-link .el-link--inner {
    color: #E7E6FA;
}

>>>.el-input .el-input__inner::-webkit-input-placeholder { /* Edge */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>>.el-input .el-input__inner:-ms-input-placeholder{ /* Internet Explorer 10-11 */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>>.el-input .el-input__inner::placeholder{
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>>div.el-tabs__item {
    color: #E7E6FA;
}

>>>div.el-tabs__item.is-active {
    color: #50C6DF;
}

>>>div.el-tabs__active-bar {
    background-color: #50C6DF;
}

.el-button.avatar,
>>>.el-button.avatar span {
    font-size: 16px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #E7E6FA;
    border: none;
}

.el-button.avatar span {
    width: 40px !important;
    height: 40px !important;
    margin: 0 8px 0 0 !important;
}

@media (max-width: 380px) {
    >>>.el-dialog{
        width: calc(100% - 30px) !important;
    }
}

</style>
